import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { PercentText } from '../PercentText/PercentText';
import { ValueOrDash } from '../ValueOrDash/ValueOrDash';

interface Props {
    num?: number;
    fractionalPartLength?: number;
}

export class PercentCell extends React.PureComponent<Props> {
    render() {
        const { num, fractionalPartLength } = this.props;

        return (
            <div className={Bem.cls('percent-cell')}>
                <ValueOrDash value={num}>
                    <PercentText num={num} fractionalPartLength={fractionalPartLength} />
                </ValueOrDash>
            </div>
        );
    }
}
